import { useMerchant } from '../../../../contexts/MerchantContext';
import { useGetMerchantQuery, useGetOnboardingQuery } from '../../../../store/modules/merchant/api';
import { isBigCommerceMerchant } from '../../../../util/bigcommerceExternalId';

/** Whether Agent Hub should expose BigCommerce provisioning for the current merchant. */
export const useBigCommerceProvisioningEligibility = () => {
  const { merchantId } = useMerchant();
  const { data: merchant, isLoading: isMerchantLoading } = useGetMerchantQuery(merchantId ?? '', {
    skip: !merchantId,
  });

  const isBigCommerceStore = isBigCommerceMerchant(merchant?.externalPlatformId);
  const merchantPlatformResolved = Boolean(merchantId) && !isMerchantLoading;
  const shouldFetchOnboarding = merchantPlatformResolved && isBigCommerceStore;

  const {
    data: onboarding,
    isLoading: isOnboardingLoading,
    isError: isOnboardingError,
    isSuccess: hasOnboarding,
    refetch: refetchOnboarding,
  } = useGetOnboardingQuery(
    { merchantId: merchantId ?? '', systemOfOrigin: 'bigcommerce' },
    { skip: !shouldFetchOnboarding },
  );

  const isEligible = isBigCommerceStore;
  const isLoading =
    isMerchantLoading ||
    (shouldFetchOnboarding && isOnboardingLoading && !onboarding && !isOnboardingError);

  return {
    merchantId,
    merchant,
    onboarding: onboarding?.systemOfOrigin === 'bigcommerce' ? onboarding : undefined,
    isBigCommerceStore,
    isEligible,
    isLoading,
    hasOnboarding,
    isOnboardingError,
    refetchOnboarding,
  };
};
